module.exports = __webpack_public_path__ + "img/waterPpl@2x.0e64f143.png";